import React from "react";
import styled from "styled-components";
import Image from "next/image";
import * as Router from "next/router";

import * as UserContext from "./UserContext";
import * as gtag from "../utils/gtag";
import firebase from "../firebase.client";
import * as T from "./Typography";
import * as I from "./Icons";
import * as u from "../utils";
import { recommendationColour } from "@/utils/colours";
import RxLink from "./ui/inputs/RxLink";

export default function Lesson(props) {
  const router = Router.useRouter();
  const userInfo = React.useContext(UserContext.Context);
  const saved =
    props.savedCourseIds && props.savedCourseIds.includes(props.sys.id);
  const tag = (props.contentfulMetadata?.tags.map(
    (tag) => tag.name.split(": ")[1]
  ) ?? [])[0];
  // const isPaidUser = userInfo.isPaid;
  // const isFree = props.isFree;
  const isLoggedIn = userInfo.id;
  // const showPadlock = isLoggedIn && !isPaidUser && !isFree;
  // const showUnlocked = isLoggedIn && isPaidUser && !isFree;

  return (
    <S.Lesson href={`/academy/course/${props.urlSlug}`}>
      <S.InnerWrap>
        <S.VideoOverlay>
          <S.VideoOverlayBlock />
          <S.VideosText weight={600} colour="white">
            {props.lessonActivitiesCollection.total}
            <S.VideoIconWrap>
              <I.PlayCircle colour="white" height="18px" width="18px" />
            </S.VideoIconWrap>
          </S.VideosText>
        </S.VideoOverlay>
        <S.ImageWrapper>
          {props?.coverImage?.url && (
            <Image
              src={props.coverImage.url || ""}
              alt={props.coverImage.title}
              layout="fill"
              objectFit="cover"
              objectPosition="right"
            />
          )}
        </S.ImageWrapper>
        <S.ContentWrapper>
          <S.Ribbons>
            {/* {showPadlock && <I.PlusLocked data-cy={"academy-padlock"} />}
            {showUnlocked && <I.PlusUnlocked />} */}
            <S.SavedRibbon onClick={toggleSaved}>
              {saved ? <I.RibbonFilled /> : <I.RibbonUnfilled />}
            </S.SavedRibbon>
          </S.Ribbons>
          <S.InfoWrapper>
            <T.CS weight={600} colour={u.colours.academyOrange}>
              {tag && tag.toUpperCase()}
            </T.CS>
          </S.InfoWrapper>
          <T.H5>{props.lessonName}</T.H5>
          <S.ClippedText>{props.lessonIntroductionText}</S.ClippedText>
          <S.StartCourse>
            <S.LinkText weight={600} className="link-text">
              Start Course
              <S.Arrow className="arrow" />
            </S.LinkText>
          </S.StartCourse>
        </S.ContentWrapper>
      </S.InnerWrap>
    </S.Lesson>
  );

  // function clickCourse() {
  //   gtag.event({
  //     name: gtag.GA_EVENT.ACADEMY_ENGAGEMENT,
  //     category: "Academy",
  //     label: "From " + router.route,
  //     value: props.urlSlug,
  //   });

  //   router.push(`/academy/course/${props.urlSlug}`);
  // }

  function toggleSaved(e) {
    e.stopPropagation();

    if (!isLoggedIn && router.asPath === "/academy")
      return props.setModalType("save");

    if (saved) return unsaveCourse();
    else return saveCourse();

    async function unsaveCourse() {
      const savedCourses = firebase.firestore.FieldValue.arrayRemove(
        props.sys.id
      );
      var userRef = firebase.firestore().collection("users").doc(userInfo.id);
      await userRef.set({ savedCourses }, { merge: true });
      props.setSavedCourseIds(
        props.savedCourseIds.filter((id) => id !== props.sys.id)
      );
    }

    async function saveCourse() {
      const savedCourses = firebase.firestore.FieldValue.arrayUnion(
        props.sys.id
      );
      var userRef = firebase.firestore().collection("users").doc(userInfo.id);
      await userRef.set({ savedCourses }, { merge: true });
      props.setSavedCourseIds(props.savedCourseIds.concat(props.sys.id));

      gtag.event({
        name: gtag.GA_EVENT.ACADEMY_ENGAGEMENT,
        category: "Academy",
        label: "Save lesson",
        value: router.route,
      });
    }
  }
}

const S = {};

S.Lesson = styled(RxLink)`
  display: flex;
  position: relative;
  width: 100%;
  cursor: pointer;
  border-radius: 5px;
  overflow: hidden;
  border-right: 5px solid ${recommendationColour.course};
  transition: all 0.3s ease-in;

  box-shadow: 0 0 15px ${u.colours.charcoalFaded};

  &:hover {
    transform: scale(1.01);
    filter: brightness(1.05);
  }

  &:hover .link-text::after {
    width: 100%;
  }

  &:hover .arrow {
    margin: 0 0 0 20px;
  }

  @media ${u.device.desktop} {
    width: 49%;
  }
`;

S.InnerWrap = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
`;

S.ImageWrapper = styled.div`
  aspect-ratio: 1/1;
  width: 30%;
  position: relative;
  flex-shrink: 0;
  @media ${u.device.mobile} {
    height: 190px;
    width: 190px;
    padding-top: 0;
  }
`;

S.ContentWrapper = styled.div`
  width: 100%;
  background: linear-gradient(45deg, ${u.colours.shell}, ${u.colours.white});
  display: flex;
  flex-direction: column;
  padding: 10px 0 10px 10px;
  justify-content: space-between;
  height: 100%;

  @media ${u.device.mobile} {
    padding: 20px 40px 20px 20px;
  }
`;

S.VideoOverlay = styled.div`
  display: flex;
  align-items: center;
  z-index: 1;
  position: absolute;
`;

S.VideoOverlayBlock = styled.div`
  height: 100%;
  width: 100%;
  background: black;
  opacity: 0.5;
  position: absolute;
  border-bottom-right-radius: 10px;
`;

S.VideoIconWrap = styled.div`
  margin: 3px 0 0 1px;
`;

S.VideosText = styled(T.CS)`
  display: flex;
  align-items: center;
  padding: 0 4px 0 6px;
  z-index: 2;
`;

S.Ribbons = styled.div`
  z-index: 1;
  display: flex;
  gap: 5px;
  position: absolute;
  top: 0;
  right: 20px;
`;

S.SavedRibbon = styled.div`
  cursor: pointer;
`;

S.InfoWrapper = styled.div`
  display: flex;
`;

S.StartCourse = styled.div`
  display: flex;
  align-items: center;
`;

S.LinkText = styled(T.CS)`
  position: relative;
  color: ${recommendationColour.course};
  width: fit-content;

  &::after {
    content: "";
    position: absolute;
    width: 0;
    height: 1px;
    background-color: ${recommendationColour.course};
    bottom: -5px;
    left: 0;
    transform-origin: left;
    transition: all 0.3s ease-in;
  }
`;

S.StartCircle = styled.div`
  background: ${u.colours.academyOrange};
  height: 24px;
  width: 24px;
  margin-left: 10px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media ${u.device.mobile} {
    height: 28px;
    width: 28px;
  }
`;

S.ClippedText = styled(T.CS)`
  display: none;
  overflow: hidden;
  @media (min-width: 400px) {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  @media (min-width: 500px) {
    -webkit-line-clamp: 3;
  }
`;

S.Arrow = styled.span`
  display: inline-block;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 9px solid ${u.colours.academyOrange};
  margin-left: 15px;
  transition: all 0.3s ease-in;
`;
